import { PowerSupplyPictogram } from './PowerSupplyPictogram';
import { getWidth, aspectRatio } from './helper';

export type PowerSupplyPictogramSpecificationProps = {
  maxPower: number;
  minPower: number;
  chargerType: 'Normal' | 'PowerDelivery';
  width?: string;
};

export const PowerSupplyPictogramSpecification = ({
  maxPower,
  minPower,
  chargerType,
  width,
}: PowerSupplyPictogramSpecificationProps) => (
  <div
    style={{
      width: getWidth(width),
      aspectRatio,
      fontSize: getWidth(width),
    }}
    className="relative"
    aria-hidden="true"
  >
    <div className="font-family-efficiency-label absolute bottom-[12%] left-[15%] h-[50%] w-[70%] overflow-hidden text-center text-[0.18em] font-bold text-nowrap [&>div]:absolute [&>div]:w-full">
      <div className="top-[3.5%]">
        {minPower}-{maxPower}
      </div>
      <div className="top-[37.3%]">W</div>
      {chargerType === 'PowerDelivery' && <div className="top-[75%] text-[0.58em]">USB PD</div>}
    </div>
    <PowerSupplyPictogram width={width} type="Specification" />
  </div>
);
